import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {CreditUnionService} from "@app/services/credit-union/credit-union.service";
import {PortalUser} from "@app/model/portal-user.model";
import {LoginService} from "@app/login/login.service";
import {Router} from "@angular/router";
import {AlertsService} from "@app/services/misc-services/alerts.service";
import {MatDialog} from "@angular/material/dialog";
import {Base64ConversionService} from "@app/services/misc-services/base64-conversion.service";
import {TicketsService} from "@app/services/tickets/tickets.service";
import {TicketNoteModel} from "@app/model/ticket.model";

@Component({
    selector: 'flex-new-ticket',
    templateUrl: './new-ticket.component.html',
    styleUrls: ['./new-ticket.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewTicketComponent implements OnInit {
    //Text area placeholders
    placeholderInfo: {notePlaceholder: string, communityPlaceholder: string, enhancementPlaceholder: string} = {
        notePlaceholder: `Provide detailed information regarding this issue (outline what happened, workstation and teller ID, date of occurrence, point in workflow this issue arose, etc). Please provide screenshots or any other information needing to be added as an attachment`,
        communityPlaceholder: `Provide details outlining your ideas and information regarding the program/feature an enhancement is being requested for. Explain how the credit union would like the enhancement to function and the purpose or end goal desired. Provide screenshots or attachments to assist FLEX programming in understanding what is expected.`,
        enhancementPlaceholder: `Provide details outlining your ideas and information regarding the enhancement being requested (program/module, point in workflow, process, etc). Explain how the credit union would like the enhancement to function and the purpose or end goal desired. Provide screenshots or attachments to assist FLEX programming in understanding what is expected.`}

    //List of ticket types for dropdown
    typeDropdown: TicketTypes[] = [
        {value: '', label: 'General Support'},
        {value: 'E', label: 'Credit Union Paid Enhancement'},
        {value: 'C', label: 'Community Points'}
    ]
    activeUser: PortalUser;
    cuContacts: PortalUser[];
    allContacts: PortalUser[];
    ticketLabel: string = 'General Support';

    // alternate to the ticket above
    title: string = '';
    note: string = '';
    ticketType: string = '';
    requestedBy: PortalUser;
    enhancementDescription: string = '';
    today: Date = new Date();

    //Point handling variables
    totalCommunityPoints: number = 0;
    addedPoints: number = 0;
    availablePoints: number;

    constructor(public creditUnionService: CreditUnionService,
                public activeUserService: LoginService,
                public router: Router,
                public ticketsService: TicketsService,
                public alert: AlertsService,
                public dialog: MatDialog,
                public b64: Base64ConversionService,) {
    }

    ngOnInit(): void {
        this.router.onSameUrlNavigation = 'reload';
        this.activeUserService.getActiveUserSubject().subscribe((user) => {
            this.activeUser = user;
            this.requestedBy = this.activeUser;
        });
        this.creditUnionService.getAllPortalUsers().subscribe((allContacts) => {
            this.allContacts = allContacts
            this.cuContacts = allContacts.filter((user) => user.cuid === this.activeUser.cuid);
        })
        this.getPoints()
    }

    submitNewTicket() {
        const ticket = this.ticketsService.createTicketDTO(this.activeUser, this.title, this.ticketType);
        const note = this.ticketsService.createNoteDTO(this.note, this.activeUser, 0);
        this.ticketsService.createTicket(ticket, note, this.activeUser)
            .subscribe((savedTicket: {success: boolean, savedItem: {ticket: string, notes: TicketNoteModel[], userWhoSaved: string}}) => {
                this.ticketsService.uploadAttachmentList(savedTicket.savedItem.notes[0].ticketNumber);
                if (this.ticketType === 'C') {
                    this.ticketsService.updateCommunityPoints(this.activeUser.cuid, this.availablePoints)
                }
                this.ticketsService.refreshTicketsAndGoBack();
            })
    }

    //Point handling functions
    getPoints() {
        this.creditUnionService.getFlexPoints(this.activeUser.cuid).subscribe((response: {class: string, cuid: string, id: number, points: number, version: number}) => {
            this.availablePoints = 100 - response.points;
        })
    }
    increasePoints() {
        if (this.availablePoints > 0) {
            this.totalCommunityPoints = this.totalCommunityPoints + 5;
            this.addedPoints = this.addedPoints + 5;
            this.availablePoints = this.availablePoints - 5;
        }
    }
    decreasePoints() {
        if (this.totalCommunityPoints === 0) {
            this.totalCommunityPoints = 0;
        } else {
            this.totalCommunityPoints = this.totalCommunityPoints - 5;
            this.addedPoints = this.addedPoints - 5;
            this.availablePoints = this.availablePoints + 5;
        }
    }

    changeLabel() {
        this.ticketLabel = this.typeDropdown.find((type) => type.value === this.ticketType).label
    }

    disableSubmit() {
        if (this.ticketType === 'C' || this.ticketType === 'E') {
            return !!(this.enhancementDescription && this.title);
        } else {
            return !!(this.note && this.title);
        }
    }
}
export class TicketTypes {
    value: string;
    label: string;
}
